<template>
  <div class="cameraList w-full h-full relative">
    <el-table
      ref="tableRef"
      height="calc(100% - 40px)"
      class="mt-5px"
      :data="tableData"
      highlight-current-row
      row-key="id"
    >
      <el-table-column :label="`${$t('预案名称')}`" show-overflow-tooltip prop="name">
      </el-table-column>
      <el-table-column
        :label="`${$t('所属单位')}`"
        show-overflow-tooltip
        prop="eascOrganizationName"
      ></el-table-column>
      <el-table-column
        :label="`${$t('发布时间')}`"
        show-overflow-tooltip
        prop="publishDate"
      ></el-table-column>
      <el-table-column :label="`${$t('操作')}`" show-overflow-tooltip width="50">
        <template #default="{ row }">
          <div class="w-15 cursor-pointer text-[#00BCC8]" @click="reviewDetail(row)">查看</div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      :total="total"
      :current-page.sync="pageNo"
      :page-size.sync="pageSize"
      class="h-35px mt-5px text-center"
      layout="prev, pager, next"
      @current-change="getIotDevicePagedList"
    >
    </el-pagination>
  </div>
</template>

<script>
import { PlanApi } from '@wiz-api/emergency-management'
import dayjs from 'dayjs'
import bus from './bus'

const planApi = new PlanApi()
export default {
  name: 'PlanList',
  components: {},
  data() {
    return {
      tableData: [],
      total: 0,
      pageSize: 15,
      pageNo: 1,
      isShowDialog: false,
      listInfo: {},
      typeName: '',
    }
  },
  props: {
    transferProps: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    transferProps: {
      handler(newVal, oldVal) {
        if (!newVal) return
        if (this.typeName !== newVal?.typeName) {
          this.getIotDevicePagedList()
        }
        this.typeName = newVal?.typeName
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    async getIotDevicePagedList() {
      const [err, res] = await planApi.getList({
        typeName: this.transferProps.typeName,
        skipCount: (this.pageNo - 1) * this.pageSize,
        maxResultCount: this.pageSize,
        statusArr: ['4', '5'],
      })
      if (!err) {
        _.forEach(res.items, (tableItem) => {
          if (tableItem.publishDate) {
            tableItem.publishDate = dayjs(new Date(tableItem.publishDate)).format(
              'YYYY-MM-DD HH:mm:ss'
            )
          }
        })
        this.tableData = res.items
        this.total = res.totalCount
      }
    },
    // 查看详情
    reviewDetail(item) {
      bus.$emit('translate', { row: item, type: 'plan' })
    },
    refresh() {
      this.isShowDialog = false
    },
    currentChange() {},
  },
}
</script>
<style lang="scss" scoped></style>
